import {
  ORGANIZED_TOUR_CURATED_GENERIC_TRAVEL_URL,
  organizedTourLooksLikeDirectImageUrl,
  upgradeOrganizedTourRemoteImageUrl,
} from "../../../utils/organizedTourHeroImageSsot";

/** @typedef {{ hero_image_url?: string|null }} PublicOrgTourVm */

/**
 * URL להצגה בעמוד הציבורי / הדפסה (שדרוג פרמטרי CDN + fallback מתוך SSOT הקיים).
 *
 * @param {PublicOrgTourVm|null|undefined} publicVm
 */
export function resolveOrganizedTourPublicHeroDisplayUrl(publicVm) {
  const raw = publicVm?.hero_image_url;
  const s = typeof raw === "string" ? raw.trim() : "";
  if (!s || !organizedTourLooksLikeDirectImageUrl(s)) {
    return ORGANIZED_TOUR_CURATED_GENERIC_TRAVEL_URL;
  }
  return upgradeOrganizedTourRemoteImageUrl(s) || s;
}
